module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/1zk39IpbMQMaG6Couw8W6Q-29bbfe821d46a12e75bedf1a1dd4897d.jpg";